import PortalExample from "./examples/Portal.Example";

export default [
    {
        title: "Portal example",
        component: PortalExample,
        code: require("!raw-loader!./examples/Portal.Example.tsx")
    }
];
